import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';

const EntityNamePickerFieldSchema = makeFieldSchema({
  output: (z) => z.string()
});
const EntityNamePickerSchema = EntityNamePickerFieldSchema.schema;

export { EntityNamePickerSchema };
//# sourceMappingURL=schema.esm.js.map
